import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { Loading } from '@auto/react-comps';

//个人钱包首页
const WalletHome = lazy(() => import('./containers/WalletHome'));
const Balance = lazy(() => import('./containers/PersonalWallet/router/Balance'));
const BalanceList = lazy(() => import('./containers/PersonalWallet/router/BalanceList'));
const Deatils = lazy(() => import('./containers/PersonalWallet/router/Deatils/Deatils'));
const CashOut = lazy(() => import('./containers/PersonalWallet/router/CashOut/CashOut'));
const CashOutResult = lazy(() =>
  import('./containers/PersonalWallet/router/CashOutResult/CashOutResult'),
);
//新的卡券中心
const Coupon2020 = lazy(() => import('./containers/Coupon2020/Coupon'));
// 钱包聚合页
// const RedPacketGatherPage = lazy(() => import('./containers/RedPacketGatherPage'));
const ownerRedPacket = lazy(() => import('./containers/OwnerRedPacket'));
// 权益
const Interests = lazy(() => import('./containers/Interests/Interests'));
// 关闭加速宝
const JSB = lazy(() => import('./containers/NewWalletpage/Jiasubao'));
//汽车之家联名信用卡
const InsurancePolicy = lazy(() => import('./containers/Activity88'));
//实名绑卡合规优化
const Authen = lazy(() => import('./containers/Authen'));
//钱包首页-新的成功页
const WalletSucPage = lazy(() => import('./containers/PaySucPage'));
//一户通开户授权页
const YHTopenAccredit = lazy(() => import('./containers/YHTopenAccredit'));

const App = (location) => (
  //支付企业钱包项目 path=/biz/wallet/*
  <div className="pay_wallet">
    <Suspense fallback={<Loading />}>
      <Switch>
        {/* 交易退款提现的详情页面 */}
        <Route exact path="/m/personalwallet/detail" component={Deatils} />
        {/* 提现交易明细 */}
        <Route exact path="/m/personalwallet/balance" component={Balance} />
        <Route exact path="/m/personalwallet/balanceList" component={BalanceList} />
        {/* 提现 */}
        <Route exact path="/m/personalwallet/cashout" component={CashOut} />
        {/* 提现结果 */}
        <Route exact path="/m/personalwallet/cashoutresult" component={CashOutResult} />
        {/* 个人钱包首页 */}
        <Route location={location} path="/m/personalwallet" component={WalletHome} />
        <Route location={location} path="/m/newWalletpage" component={WalletHome} />
        <Route location={location} path="/m/wallethome" component={WalletHome} />
        {/* 新的卡券中心  */}
        <Route location={location} path="/m/Coupon2020" component={Coupon2020} />
        {/* 红包聚合页 */}
        {/* <Route exact path="/m/redPacketGatherPage" component={RedPacketGatherPage}/> */}
        <Route exact path="/m/redPacketGatherPage" component={ownerRedPacket} />
        {/* <Route location={location} path="/m/prizeTopic" component={PrizeTopic} /> */}
        {/* 权益 */}
        <Route location={location} path="/m/interests" component={Interests} />
        {/* 关闭加速宝 */}
        <Route location={location} path="/m/jsb" component={JSB} />
        {/* 汽车之家联名信用卡 */}
        <Route location={location} path="/m/activity88" component={InsurancePolicy} />
        {/* 实名绑卡合规优化 */}
        <Route location={location} path="/m/authen" component={Authen} />
        {/* 新的支付成功页 */}
        <Route location={location} path="/m/paySucPage" component={WalletSucPage} />
        {/* 一户通开户授权页 */}
        <Route location={location} path="/m/yhtopenaccredit" component={YHTopenAccredit} />
        {/*打底 个人钱包首页*/}
        <Route location={location} path="/*" component={WalletHome} />
      </Switch>
    </Suspense>
  </div>
);

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};
export default App;
